// API网关
const baseURL = '/api/';
// 服务模块
const basic = baseURL + 'erp';
const finance = baseURL + 'finance';
const wms = baseURL + 'wms/wms';
const admin = baseURL + 'erp-admin';
const bi = baseURL + 'bi';

let urls = {
  uesrLoginInfo: admin + '/sys/user/info',
  needCaptcha: admin + '/needCaptcha',
  setDefaultOrgId: admin + '/sys/user/setDefaultOrgId',
  sysDict: admin + '/sys/sysDict/item',

  selectPurchaseSaleYear: bi + '/query/bigScreenGM/selectPurchaseSaleYear',
  storageMonth: bi + '/query/bigScreenGM/storageMonth',
  selectStorageDays: bi + '/query/bigScreenGM/selectStorageDays',
  selectStorageExceedDays: bi + '/query/bigScreenGM/selectStorageExceedDays',
  purchaseSaleViewInfo: bi + '/query/bigScreenGM/purchaseSaleViewInfo',
  selectTradeMaterialNoInfo: bi + '/query/bigScreenGM/selectTradeMaterialNoInfo',
  foreignViewInfo: bi + '/query/bigScreenGM/foreignViewInfo',
  domesticViewInfo: bi + '/query/bigScreenGM/domesticViewInfo',
  selectRoute: bi + '/query/bigScreenGM/selectRoute',
  selectAnalysisFutureClassname: bi + '/query/bigScreenGM/selectAnalysisFutureClassname',
  selectAnalysisFutureCategory: bi + '/query/bigScreenGM/selectAnalysisFutureCategory',
  selectAnalysisClassname: bi + '/query/bigScreenGM/selectAnalysisClassname',
  selectAnalysisCategory: bi + '/query/bigScreenGM/selectAnalysisCategory',
  selectRmbRate: bi + '/query/bigScreenGM/selectRmbRate',
  selectAnalysisFutureProduct: bi + '/query/bigScreenGM/selectAnalysisFutureProduct',
  selectAnalysisProduct: bi + '/query/bigScreenGM/selectAnalysisProduct',

  //毛利
  grossProfit: bi + '/query/qwzy/dp/view/gross/profit',
  grossProfitNoPayment: bi + '/query/qwzy/dp/view/gross/loss',
  grossProfitbyMonth: bi + '/query/qwzy/dp/view/gross/profit/byMonth',
  grossProfitRedTop5: bi + '/query/qwzy/dp/view/gross/profit/redTop5',
  grossProfitBlackTop5: bi + '/query/qwzy/dp/view/gross/profit/blackTop5',

  //采购
  prepayAmount: bi + '/query/qwzy/dp/view/prepay/amount',
  prepayWeight: bi + '//query/qwzy/dp/view/purchase/weight',
  prepayNoPayment: bi + '/query/qwzy/dp/view/no/payment',
  prepayContractTax: bi + '/query/qwzy/dp/view/purchase/tax',
  prepayContractCount: bi + '/query/qwzy/dp/view/contract/count',
  prepaybyMonth: bi + '/query/qwzy/dp/view/purchase/byMonth',
  prepaybyMoney: bi + '/query/qwzy/dp/view/no/payment/byMoney',
  prepaySupplierTop5: bi + '/query/qwzy/dp/view/purchase/supplierTop5',

  //销售
  saleTax: bi + '/query/qwzy/dp/view/sale/tax',
  saleNoCollect: bi + '/query/qwzy/dp/view/no/collect',
  saleQueryData: bi + '/query/qwzy/dp/view/sale/data',
  saleCustomerTop5: bi + '/query/qwzy/dp/view/sale/customerTop5',
  saleNoCollectByMoney: bi + '/query/qwzy/dp/view/no/collect/byMoney',

  //库存
  stockQueryData: bi + '/query/qwzy/dp/view/stock/data',
  stockTodayData: bi + '/query/qwzy/dp/view/stock/today',
  stockInOutByMonth: bi + '/query/qwzy/dp/view/stock/inOutByMonth',
  stockDataHistory: bi + '/query/qwzy/dp/view/stock/history',
  stockWarehouse: bi + '/query/qwzy/dp/view/stock/warehouse',
  stockAging: bi + '/query/qwzy/dp/view/stock/aging',
};

export default urls



// WEBPACK FOOTER //
// ./src/utils/urls.js